import { createSlice } from '@reduxjs/toolkit';

import { TIMEKEEPING_STATUSES } from './timekeepingConstants';
import { getCalculatedTimecardsOnUpdate } from './timekeepingHelpers';

const initialState = {
  timekeepingOverviewData: {},
  timecards: [],
  batchActionError: null,
  totalTimecardsCount: 0,
  isTimecardsLoading: false,
  isOverviewDataReload: false,
  isApproveTimecardsLoading: false,
  isFinalizeTimecardsLoading: false,
  isResolveTimecardsLoading: false,
  isTimekeepingOverviewDataLoading: false,
  isUpdatingTimecard: false,
  isUpdatingDepartments: false,
  isDisputedTimecardUpdating: false,
  isReloadTimecards: false,
  timecardActionIsProcessing: false,
};

export const timekeepingSlice = createSlice({
  name: 'timekeepingSlice',
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    getTimekeepingOverviewData: (state) => {
      state.isTimekeepingOverviewDataLoading = true;
    },

    getTimekeepingOverviewDataProcessed: (state, action) => {
      state.isTimekeepingOverviewDataLoading = false;
      state.timekeepingOverviewData = action.payload.data;
      state.isOverviewDataReload = false;
    },

    getTimekeepingOverviewDataError: (state) => {
      state.isTimekeepingOverviewDataLoading = false;
      state.isOverviewDataReload = false;
    },
    getTimekeepingOverviewDataV2: (state) => {
      state.isTimekeepingOverviewDataLoading = true;
    },
    getTimekeepingOverviewDataProcessedV2: (state, action) => {
      state.isTimekeepingOverviewDataLoading = false;
      state.timekeepingOverviewData = action.payload.data;
    },
    getTimekeepingOverviewDataErrorV2: (state) => {
      state.isTimekeepingOverviewDataLoading = false;
    },
    getTimecards: (state) => {
      state.isTimecardsLoading = true;
    },
    getTimecardsProcessed: (state, action) => {
      state.isTimecardsLoading = false;
      const { documents, count } = action.payload.data;
      state.timecards = documents;
      state.totalTimecardsCount = count;
    },
    getTimecardsError: (state) => {
      state.isTimecardsLoading = false;
    },
    timecardEditV2: (state) => {
      state.isUpdatingTimecard = true;
    },
    timecardEditV2Processed: (state, action) => {
      state.isUpdatingTimecard = false;
      const document = action.payload?.data?.document;
      const getCurrentPlacements = state.timecards.map((currentItem) =>
        currentItem?.candidate?._id !== document?.candidate?._id
          ? currentItem
          : getCalculatedTimecardsOnUpdate(currentItem, document)
      );

      state.timecards = getCurrentPlacements;
      state.shouldTimekeepingOverviewReload = true;
    },
    timecardEditV2Error: (state) => {
      state.isUpdatingTimecard = false;
    },
    updateTimekeepingDepartments: (state) => {
      state.isUpdatingDepartments = true;
    },
    updateTimekeepingDepartmentsProcessed: (state) => {
      state.isUpdatingDepartments = false;
    },
    updateTimekeepingDepartmentsError: (state) => {
      state.isUpdatingDepartments = false;
    },
    updateDisputedTimecard: (state) => {
      state.isDisputedTimecardUpdating = true;
    },
    updateDisputedTimecardProcessed: (state, action) => {
      state.isDisputedTimecardUpdating = false;
      const document = action?.payload?.data?.document;
      const getCurrentPlacements = state.timecards.map((currentItem) =>
        currentItem?.candidate?._id !== document?.candidate?._id
          ? currentItem
          : getCalculatedTimecardsOnUpdate(currentItem, document)
      );

      state.timecards = getCurrentPlacements;
      state.shouldTimekeepingOverviewReload = true;
    },
    updateDisputedTimecardError: (state) => {
      state.isDisputedTimecardUpdating = false;
    },
    postTimeCardUnFinalize: (state) => {
      state.timecardActionIsProcessing = true;
    },
    postTimeCardUnFinalizeProcessed: (state, action) => {
      state.timecardActionIsProcessing = false;
      const placements = action?.payload?.data?.placements;

      state.timecards = state.timecards.map((candidate) => ({
        ...candidate,
        timecards: candidate.timecards.map((t) =>
          placements?.includes(t.placementId)
            ? { ...t, timecard: { ...t.timecard, status: TIMEKEEPING_STATUSES.RESOLVED } }
            : t
        ),
      }));
    },
    postTimeCardUnFinalizeError: (state) => {
      state.timecardActionIsProcessing = false;
    },
  },
});

export const timekeepingReducer = timekeepingSlice.reducer;

export const {
  getTimekeepingOverviewData,
  getTimekeepingOverviewDataV2,
  getTimekeepingOverviewDataProcessed,
  getTimekeepingOverviewDataProcessedV2,
  getTimekeepingOverviewDataError,
  getTimekeepingOverviewDataErrorV2,
  getTimecards,
  getTimecardsProcessed,
  getTimecardsError,
  updateDisputedTimecard,
  updateDisputedTimecardProcessed,
  updateDisputedTimecardError,
  postTimeCardUnFinalize,
  postTimeCardUnFinalizeProcessed,
  postTimeCardUnFinalizeError,
  timecardEditV2,
  timecardEditV2Processed,
  timecardEditV2Error,
  updateTimekeepingDepartments,
  updateTimekeepingDepartmentsProcessed,
  updateTimekeepingDepartmentsError,
  clearBatchActionErrorAndCount,
} = timekeepingSlice.actions;
